import { Injectable, inject } from '@angular/core';
import { ShiftTemplate, TimelineShiftWithActivities } from '@wilson/interfaces';
import { ShiftTemplateToShiftService } from '@wilson/non-domain-specific/shift-helpers/core';
import { CreateNewViaDragAndDropService } from '@wilson/shift-timeline/services';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ShiftTemplateHelperService {
  private shiftTemplateToShiftService = inject(ShiftTemplateToShiftService);

  private shiftTemplateSubject = new BehaviorSubject<ShiftTemplate | null>(
    null,
  );
  public shiftTemplate$ = this.shiftTemplateSubject.asObservable();

  public setShiftTemplate(shiftTemplate: ShiftTemplate | null): void {
    this.shiftTemplateSubject.next(shiftTemplate);
  }

  public getShiftOfShiftTemplate(
    userId: string,
    startDate: string,
  ): TimelineShiftWithActivities | null {
    const shiftTemplate = this.shiftTemplateSubject.value;
    if (shiftTemplate) {
      const materializedShift =
        this.shiftTemplateToShiftService.createShiftFromTemplateWithSelectedDate(
          shiftTemplate,
          new Date(startDate),
        );

      return {
        ...materializedShift,
        id: CreateNewViaDragAndDropService.MOCK_SHIFT_ID,
        userId: userId,
        startDate: startDate,
        priority: null,
      } as TimelineShiftWithActivities;
    } else {
      return null;
    }
  }
}
